import { type TriageCardRow, TriageCardRowSchema } from '@voll-intelligence/domain';
import { z } from 'zod';

import type { HttpService } from '@web/data/services';

const TriageCardRowsSchema = z.array(TriageCardRowSchema);
const RetriageResponseSchema = z.object({ requested: z.number().int().nonnegative() });

interface TriageInboxRepository {
  loadTriageCards: (orgId: string) => Promise<TriageCardRow[]>;
  /** Re-runs automatic triage for every open untriaged card. */
  retriageUntriaged: (orgId: string) => Promise<{ requested: number }>;
}

export function createTriageInboxRepository(http: HttpService): TriageInboxRepository {
  return {
    loadTriageCards: (orgId) =>
      http.get(`/orgs/${orgId}/triage-cards`, { schema: TriageCardRowsSchema }),
    retriageUntriaged: (orgId) =>
      http.post(`/orgs/${orgId}/cards/retriage-untriaged`, {}, { schema: RetriageResponseSchema }),
  };
}
